var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require('@/assets/images/main-logo.png')}})]),_c('h1',[_vm._v("慢箋得來速")])])}
var staticRenderFns = []

export { render, staticRenderFns }